import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/features/auth/api/auth.queries";
import { splitsQueryOptions } from "@/features/splits/api/splits.queries";
import { SplitsPage } from "@/features/splits/SplitsPage";
import { canManageRaids } from "@/shared/lib/roles";

export const Route = createFileRoute("/_app/splits")({
  beforeLoad: async ({ context }) => {
    // Parent _app guard ensured auth + non-applicant (me cached); this narrows to officers/admins.
    const me = await context.queryClient.fetchQuery(meQueryOptions);
    if (!canManageRaids(me.permissionRole)) {
      throw redirect({ to: "/" });
    }
  },
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(splitsQueryOptions),
  component: SplitsPage,
});
